import { createContext, useContext, useEffect, useState, type ReactNode } from "react";

export type Crumb = { label: string; to?: string };

const CrumbContext = createContext<{ crumbs: Crumb[]; setCrumbs: (c: Crumb[]) => void }>({
  crumbs: [],
  setCrumbs: () => {},
});

export function CrumbProvider({ children }: { children: ReactNode }) {
  const [crumbs, setCrumbs] = useState<Crumb[]>([]);
  return <CrumbContext.Provider value={{ crumbs, setCrumbs }}>{children}</CrumbContext.Provider>;
}

export const useCrumbTrail = () => useContext(CrumbContext).crumbs;

/**
 * Declares the page's place in the header trail. Pages pass the full path,
 * last item without `to`. Keyed by the joined labels so a record's name
 * arriving after its fetch updates the trail without looping.
 */
export function useCrumbs(crumbs: Crumb[]) {
  const { setCrumbs } = useContext(CrumbContext);
  const key = crumbs.map((c) => `${c.label}|${c.to ?? ""}`).join("/");
  useEffect(() => {
    setCrumbs(crumbs);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, setCrumbs]);
}
